import { createContext, useContext } from "react"

import type { AlertSettingAccordion } from "types/alerts.types"
import type { EntityType } from "types/common.types"

export type AlertSettingEntity = Extract<EntityType, "device" | "powerline" | "tower">

interface AlertSettingDrawerContextValue {
  openCreate: (entity: AlertSettingEntity, entityId: number) => void
  openEdit: (alertSetting: AlertSettingAccordion) => void
  // Closes, asking first when the open form has unsaved changes.
  requestClose: () => void
  setDirty: (dirty: boolean) => void
}

export const AlertSettingDrawerContext =
  createContext<AlertSettingDrawerContextValue | null>(null)

export const useAlertSettingDrawer = () => {
  const context = useContext(AlertSettingDrawerContext)
  if (!context) {
    throw new Error(
      "useAlertSettingDrawer must be used inside AlertSettingDrawerProvider",
    )
  }
  return context
}
